import styled from 'styled-components/macro';
import DatePicker from 'react-datepicker';
import { calendar, information } from '../../assets/icons';

export const DatepickerContainer = styled.div<{
  isOpen: boolean;
  isDisabled?: boolean;
}>`
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => (props.isOpen ? '#2d67d8' : '#ced5de')};
  box-shadow: ${(props) => (props.isOpen ? '0 0 0 4px #e0eeff' : 'none')};
  transition: all 0.2s;
  cursor: default;

  opacity: ${(props) => (props.isDisabled ? '0.6' : '1')};
  pointer-events: ${(props) => (props.isDisabled ? 'none' : '')};

  * {
    cursor: ${(props) => (props.isDisabled ? 'default' : '')};
  }

  :hover {
    border-color: #9da6b4;
  }

  .react-datepicker-wrapper {
    flex: 1;
  }
`;

export const Description = styled.span`
  color: #697180;
  font-size: 16px;
  line-height: 20px;
  cursor: inherit;
  width: 18px;
  margin-right: 8px;
  white-space: nowrap;
`;

export const Picker = styled(DatePicker)`
  border: none;
  outline: none;
  font-size: 14px;
  line-height: 20px;

  text-transform: ${(props) => (props.showMonthYearPicker ? 'capitalize' : '')};
`;

export const PickerLabel = styled.label`
  margin-left: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CalendarIcon = styled.img.attrs({ src: calendar })`
  width: 16px;
  height: 16px;
`;

export const Informer = styled.div`
  padding: 8px;
  display: flex;
  gap: 6px;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  background-color: #f8f9fa;
`;

export const Message = styled.span`
  color: #495466;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`;

export const InfoIcon = styled.img.attrs({ src: information })`
  width: 16px;
  height: 16px;
`;
